import moment from 'moment';

export default [
	{
		name: 'Name',
		field: 'name',
		width: 'large'
	},
	{
		name: 'Offers',
		field: 'body',
		width: 'large'
	},
	{
		name: 'Status',
		field: 'status',
		width: 'small',
	},
	{
		name: 'Delivery Method',
		field: 'delivery_method',
		width: 'medium'
	},
	{
		name: 'Delivery',
		field: 'delivery_date',
		width: 'large',
		prepData: (data) => {
			return moment(data.delivery_date).format('MMMM Do, YYYY h:mm A');
		}
	},
	{
		name: 'Members',
		field: 'member_count',
		width: 'small'
	}
]



/** WEBPACK FOOTER **
 ** ./src/tables/campaigns.js
 **/